import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const Oracle = ({ height = 24, width = 24, ...props }: SvgIconProps) => (
  <SvgIcon
    data-test="Oracle"
    height={height}
    width={width}
    title="Oracle logo"
    titleId="oracle-logo-title"
    viewBox="0 0 32 20"
    {...props}
  >
    <path
      fill="none"
      stroke="#C74634"
      strokeWidth="4"
      d="m10,2a8,8 0 1,0 0,16h12a8,8 0 1,0 0-16z"
    />
  </SvgIcon>
);
